import { render, staticRenderFns } from "./QSelectbox.vue?vue&type=template&id=4fe740d0&"
import script from "./QSelectbox.vue?vue&type=script&lang=ts&"
export * from "./QSelectbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports